import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { DepartmentComponent } from "src/app/pages/department/department.component";
/*admin*/
import { UserManagementComponent } from "./pages/user-management/user-management.component";
import { ScheduleComponent } from "./pages/schedule/schedule.component";
import { CourseComponent } from "src/app/pages/course/course.component";
import { SubjectComponent } from "src/app/pages/subject/subject.component";
import { RaspberryDeviceComponent } from "src/app/pages/raspberry-device/raspberry-device.component";
import { ClassroomComponent } from "src/app/pages/classroom/classroom.component";
import { HardwareMappingComponent } from "src/app/pages/hardware-mapping/hardware-mapping.component";
import { AudioDeviceComponent } from "src/app/pages/audio-device/audio-device.component";
import { CameraComponent } from "src/app/pages/camera/camera.component";
import { BatchComponent } from "src/app/pages/batch/batch.component";
import { AdminGuard } from "src/app/auth-guard/admin.guard";
import { CommonGuard } from "src/app/auth-guard/common.guard";
import { ProfessorManagementComponent } from "src/app/pages/professor-management/professor-management.component";
import { StudentManagementComponent } from "src/app/pages/student-management/student-management.component";
import { VendorManagementComponent } from "src/app/pages/vendor-management/vendor-management.component";
import { StudentVideoSearchComponent } from "src/app/pages/student-video-search/student-video-search.component";
import { ProfessorVideoSearchComponent } from "src/app/pages/professor-video-search/professor-video-search.component";
import { PendingApprovalComponent } from "src/app/pages/pending-approval/pending-approval.component";
import { LoginComponent } from "./pages/login/login.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { UpdatePasswordComponent } from "./pages/update-password/update-password.component";
import { ProDashboardComponent } from "./pages/pro-dashboard/pro-dashboard.component";
import { ChangePasswordComponent } from "./pages/change-password/change-password.component";
import { MyProfileComponent } from "./pages/my-profile/my-profile.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { FileServerComponent } from "./pages/file-server/file-server.component";
import { VideoListComponent } from "./pages/report-menu/video-list/video-list.component";
import { ScheduleHistoryComponent } from "./pages/report-menu/schedule-history/schedule-history.component";
import { VideoDetailsComponent } from "./pages/video-details/video-details.component";
import { ProfessorUpcomingScheduleComponent } from "./pages/professor-upcoming-schedule/professor-upcoming-schedule.component";
import { StudentExpiredComponent } from "./pages/report-menu/student-expired/student-expired.component";
import { PrivacyPolicyComponent } from "./pages/privacy-policy/privacy-policy.component";
import { VideocutplayComponent } from "./components/videocutplay/videocutplay.component";
import { PlayvideoComponent } from "./pages/playvideo/playvideo.component";
import { LiveclassComponent } from "./pages/liveclass/liveclass.component";
import { LiveclasslistComponent } from "./pages/liveclasslist/liveclasslist.component";
import { LiveprofessorclassComponent } from "./pages/liveprofessorclass/liveprofessorclass.component";
import { VideoReportComponent } from "./pages/report-menu/video-report/video-report.component";
import { VideoReportsNewlistComponent } from "./pages/report-menu/video-reports-newlist/video-reports-newlist.component";
import { AudioReportComponent } from "./pages/report-menu/audio-report/audio-report.component";
import { HealthCheckupComponent } from "./pages/health-checkup/health-checkup.component";
import { ReportLoginComponent } from "./pages/report-menu/report-login/report-login.component";
import { SummaryReportComponent } from "./pages/report-menu/summary-report/summary-report.component";
import { DailyReportComponent } from "./pages/report-menu/daily-report/daily-report.component";
import { DepartmentSummaryComponent } from "./pages/report-menu/department-summary/department-summary.component";
import { NonaudibleRecordsComponent } from "./pages/report-menu/nonaudible-records/nonaudible-records.component";
import { StaffUsageReportComponent } from "./pages/report-menu/staff-usage-report/staff-usage-report.component";
import { DetailedStaffUsageReportComponent } from "./pages/report-menu/detailed-staff-usage-report/detailed-staff-usage-report.component";
import { HodGuard } from "./auth-guard/hod.guard";
import { NonapprovalReportComponent } from "./pages/report-menu/nonapproval-report/nonapproval-report.component";
import { MyDepartmentClassesComponent } from "./pages/my-department-classes/my-department-classes.component";
import { SessionMasterComponent } from "./pages/session-master/session-master.component";
import { OutloginplayvideoComponent } from "./pages/outloginplayvideo/outloginplayvideo.component";
import { ApprovedVideosComponent } from "./pages/approved-videos/approved-videos.component";
import { UnapprovalVideosComponent } from "./pages/unapproval-videos/unapproval-videos.component";
const routes: Routes = [
  {
    path: "dashboard",
    component: DashboardComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "student-video",
    component: StudentVideoSearchComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "professor-video",
    component: ProfessorVideoSearchComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "pending",
    component: PendingApprovalComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "approved",
    component: UnapprovalVideosComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "course",
    component: CourseComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "batch",
    component: BatchComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },

  {
    path: "camera",
    component: CameraComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },

  {
    path: "subjects",
    component: SubjectComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "raspberry-device",
    component: RaspberryDeviceComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "classroom",
    component: ClassroomComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "session-master",
    component: SessionMasterComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "my-department-classes",
    component: MyDepartmentClassesComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "audio-device",
    component: AudioDeviceComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "hardware-mapping",
    component: HardwareMappingComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "health-checkup",
    component: HealthCheckupComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "department",
    component: DepartmentComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "user",
    component: UserManagementComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "professor",
    component: ProfessorManagementComponent,
    pathMatch: "full",
    canActivate: [HodGuard],
  },
  {
    path: "student",
    component: StudentManagementComponent,
    pathMatch: "full",
    canActivate: [HodGuard],
  },
  {
    path: "customer",
    component: VendorManagementComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "timetable",
    component: ScheduleComponent,
    pathMatch: "full",
    canActivate: [AdminGuard],
  },
  {
    path: "",
    component: LoginComponent,
    pathMatch: "full",
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    pathMatch: "full",
  },
  {
    path: "otp-verify",
    component: ResetPasswordComponent,
    pathMatch: "full",
  },
  {
    path: "update-password",
    component: UpdatePasswordComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "view-video/:id",
    component: ProDashboardComponent,

    canActivate: [CommonGuard],
  },
  {
    path: "change-password",
    component: ChangePasswordComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "my-profile",
    component: MyProfileComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },

  {
    path: "file-server",
    component: FileServerComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "video-list",
    component: VideoListComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "video-report",
    component: VideoReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "approved-videos",
    component: ApprovedVideosComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "nonaudible-report",
    component: NonaudibleRecordsComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "nonapproval-report",
    component: NonapprovalReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "audio-report",
    component: AudioReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "video-access-report",
    component: VideoReportsNewlistComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },

  {
    path: "report-login",
    component: ReportLoginComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "summary-report",
    component: SummaryReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "daily-report",
    component: DailyReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "department-summary",
    component: DepartmentSummaryComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "staff-usage-report",
    component: StaffUsageReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "detailed-staff-usage-report",
    component: DetailedStaffUsageReportComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "schedule-history",
    component: ScheduleHistoryComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "video-details",
    component: VideoDetailsComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "upcoming-schedule",
    component: ProfessorUpcomingScheduleComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "student-existing",
    component: StudentExpiredComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    pathMatch: "full",
  },
  {
    path: "video/edit",
    component: VideocutplayComponent,
    pathMatch: "full",
  },
  {
    path: "video/play",
    component: PlayvideoComponent,
    pathMatch: "full",
  },
  {
    path: "video/external",
    component: OutloginplayvideoComponent,
    pathMatch: "full",
  },
  {
    path: "streaming/class/:video_id",
    component: LiveclassComponent,
    pathMatch: "full",
  },
  {
    path: "class/onlive/list",
    component: LiveclasslistComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
  {
    path: "stream/myclass/:video_id",
    component: LiveprofessorclassComponent,
    pathMatch: "full",
    canActivate: [CommonGuard],
  },
];
@NgModule({
  imports: [CommonModule, BrowserModule, RouterModule.forRoot(routes, {})],
  exports: [],
})
export class AppRoutingModule {}
